var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera22X22(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13 8.492a2.092 2.092 0 1 0 0-4.184 2.092 2.092 0 0 0 0 4.184Z",
    stroke: "#2C3141",
    strokeWidth: 0.654,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92 4.83C9.27 3.786 10.315 3 11.45 3a2.716 2.716 0 0 1 2.702 2.703 2.716 2.716 0 0 1-2.702 2.702c-.96.087-1.831-.436-2.354-1.22M14.5 12.067v3.661a.874.874 0 0 1-.872.872H4.91a.874.874 0 0 1-.871-.872v-5.492c0-.436.348-.872.871-.872h8.631c.175 0 .349.087.523.174.175.175.349.436.349.698M17.464 10.149l-2.877 1.656c-.087.087-.087.087-.087.175v1.743c0 .087 0 .087.087.174l2.877 1.744c.262.174.698 0 .698-.174v-5.144c0-.174-.436-.261-.698-.174Z",
    stroke: "#2C3141",
    strokeWidth: 0.654,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera22X22);
export default __webpack_public_path__ + "static/media/camera-22x22.5688115ccd54706c1f29ce5d42436346.svg";
export { ForwardRef as ReactComponent };